import {useContext} from 'react'

import cx from 'classnames'
import PropTypes from 'prop-types'

import {atomIconSizes} from '@s-ui/react-atom-icon'
import {useSuiContext} from '@s-ui/react-context'
import {AuthenticationContext} from '@adv-mt/mt-context-authentication'
import IconHeartOutline from '@adv-mt/mt-svg-icons/lib/HeartOutline'
import IconHeartSolid from '@adv-mt/mt-svg-icons/lib/HeartSolid'

const CardAdFavHeart = ({isFavorite = false, onClick, adTitle}) => {
  const {i18n} = useSuiContext()
  const {isLogged} = useContext(AuthenticationContext)

  const isMarkedFavorite = isFavorite && isLogged

  const className = cx('mt-CardAd-fav', {
    'mt-CardAd-fav--added': isMarkedFavorite
  })

  const iconProps = {
    color: 'currentColor',
    size: atomIconSizes.medium
  }

  return (
    <div
      aria-label={`${i18n.t(isMarkedFavorite ? 'FAVORITES.REMOVE' : 'FAVORITES.ADD')}: ${adTitle}`}
      className={className}
      onClick={onClick}
      role="button"
      tabIndex={0}
      {...(!isLogged && {'aria-haspopup': 'dialog'})}
    >
      <div className="mt-CardAd-favIcon">
        {isMarkedFavorite ? <IconHeartSolid {...iconProps} /> : <IconHeartOutline {...iconProps} />}
      </div>
    </div>
  )
}

CardAdFavHeart.displayName = 'CardAdFavHeart'
CardAdFavHeart.propTypes = {
  adTitle: PropTypes.string,
  isFavorite: PropTypes.bool,
  onClick: PropTypes.func
}

export default CardAdFavHeart
